import React, { Component, BaseSyntheticEvent } from 'react';
import { CQMasterDataStore } from './../../../store/cq-master-data.store';
import TemplateConfigurationController from './../template-config.controller';
import { TemplateSFObjectStore } from './../../../store/models/template-object.model';
import { CQAppConstant } from './../../../app-constants';
import { observer } from 'mobx-react';


class AddNbaModal extends Component<any, any>{

    private readonly templateConfigCtrl: TemplateConfigurationController;
    constructor(props: any) {
        super(props);
        this.templateConfigCtrl = new TemplateConfigurationController();
        this.state = {
            nbaType:'',
            notification:'',
            url:'',
            name:'',
            label:''
        }
    }

    /**
     * @memberof AddNbaMOdal
     * @param e 
     * @description sets nbaType and resets other fields
     */ 
    onNbaTypeChange = (e:BaseSyntheticEvent) => {
        if(e.target.value==='QuickAction'){
            const selectedObjectName = CQMasterDataStore.OutputConfig.getSelectedObject(CQAppConstant.CQNBA);
            this.templateConfigCtrl.getQuickActions(selectedObjectName);
        }
        this.setState({
            nbaType: e.target.value,
            notification:'',
            url:'',
            name:'',
            label:''
        });
    }

    /**
     * @memberof AddNbaModal
     * @param e 
     * @description sets the url or message value
     */
    public onUrlOrMsgChange = (e:BaseSyntheticEvent) => {
        this.setState({
            [this.state.nbaType]: e.target.value
        })
    }

    /**
     * @memberof AddNbaModal
     * @param e
     * @description sets the label field 
     */
    public onLabelChange = (e:BaseSyntheticEvent) => {
        this.setState({
            label: e.target.value
        })
    }

    /**
     * @memberof AddNbaModal
     * @description sets apinameValue from state values
     * @returns apinamevalue derived from url and label
     */
    public generateApiName = () => {
        let apiName:string = '';
        let label:string = this.state.label.replace(/\s/g, '');
        if(this.state.nbaType === CQAppConstant.NBA_TYPES.URL){
            apiName=CQAppConstant.NBA_PREFIX.URL_PREFIX+label;
        }else if(this.state.nbaType === CQAppConstant.NBA_TYPES.NOTIFICATION){
            apiName=CQAppConstant.NBA_PREFIX.NOTIFICATION_PREFIX+label;
        }else{
            apiName=this.state.name;
        }
        return apiName;
    }

    /**
     * @memberof AddNbaModal
     * @param e 
     * @description sets name and label for quick action type
     */
    public setQuickAction = (e:BaseSyntheticEvent) => {
        const arrayOfQuickAction = e.target.value.split(':');
        this.setState({
            name: arrayOfQuickAction[0],
            label:arrayOfQuickAction[1]
        })
    }

    /**
     * @memberof AddNbaModal
     * @description saves the NBA button properties in store
     */
    public saveQuickActions = () => {
        const quickActionsInStore = [ ...CQMasterDataStore.OutputConfig.getQuickActions(CQAppConstant.CQNBA) ];
        const apiName :string = this.generateApiName();
        if(this.state.nbaType === CQAppConstant.NBA_TYPES.URL){
            quickActionsInStore.push({fullName:apiName, url:this.state[this.state.nbaType], type:this.state.nbaType, label:this.state.label})
        }else if(this.state.nbaType === CQAppConstant.NBA_TYPES.NOTIFICATION){
            quickActionsInStore.push({fullName:apiName, notification:this.state[this.state.nbaType], type:this.state.nbaType, label:this.state.label})
        }
        else{
            quickActionsInStore.push({fullName:this.state.name, type:this.state.nbaType, label:this.state.label});
        }
        CQMasterDataStore.OutputConfig.setQuickActions(CQAppConstant.CQNBA, quickActionsInStore);
        this.props.toggleNbaModalVisibility();
    }

    render() {
        return (
            <>
                <section role="dialog" className="slds-modal slds-fade-in-open slds-modal_small">
                    <div className="slds-modal__container">
                        <header className="slds-modal__header">
                            <h2 className="slds-text-heading_medium slds-hyphenate">Add NBA</h2>
                            <p></p>
                        </header>
                        <div className="slds-modal__content slds-p-around_medium" id="modal-content-id-1">
                            <>
                                <div className="slds-grid slds-grid_vertical ">
                                    <div className="slds-form-element slds-form-element_horizontal slds-col slds-size_1-of-2">
                                        <label className="slds-form-element__label slds-text-body_medium" htmlFor="select-01">Type</label>
                                        <div className="slds-form-element__control">
                                            <div className="slds-select_container">
                                                <select className="slds-select" id="select-01" onChange={this.onNbaTypeChange}>
                                                    <option value="None">None</option>
                                                    <option value="QuickAction">Quick Action</option>
                                                    <option value="url">url</option>
                                                    <option value="notification">Message</option>    
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    { this.state.nbaType && this.state.nbaType!=='None' &&
                                      <>  <div className="slds-form-element slds-form-element_horizontal slds-size_1-of-2">
                                            <label className="slds-form-element__label slds-text-body_medium" htmlFor="select-01">{this.state.nbaType===CQAppConstant.NBA_TYPES.NOTIFICATION?'Message':this.state.nbaType}</label>
                                            <div className="slds-form-element__control">
                                                {this.state.nbaType===CQAppConstant.NBA_TYPES.QUICK_ACTION &&
                                                    <div className="slds-select_container">
                                                        <select className="slds-select" id="select-01" onChange={this.setQuickAction}>
                                                            <option value="Please Select">Please select</option>
                                                            {TemplateSFObjectStore.quickActions.map((quickAction) => {
                                                                return (<option key={quickAction.DeveloperName} value={quickAction.DeveloperName+':'+quickAction.Label}>
                                                                            {quickAction.Label} - {quickAction.DeveloperName}
                                                                        </option>);
                                                            })};   
                                                        </select>
                                                    </div>
                                                }
                                                {this.state.nbaType!==CQAppConstant.NBA_TYPES.QUICK_ACTION &&
                                                    <input type='text'
                                                        role='input'
                                                        value={this.state[this.state.nbaType]}
                                                        onChange={this.onUrlOrMsgChange}
                                                        className="slds-input slds-combobox__input slds-combobox__input-value" />          
                                                }
                                            </div>  
                                        </div>
                                        <div className="slds-form-element slds-form-element_horizontal slds-size_1-of-2">
                                            <label className="slds-form-element__label slds-text-body_medium" htmlFor="select-01">Label</label>
                                            <div className="slds-form-element__control">
                                                <input type='text'
                                                    role='input'
                                                    value={this.state.label}
                                                    onChange={this.onLabelChange}
                                                    className="slds-input slds-combobox__input slds-combobox__input-value" />
                                            </div>
                                        </div>
                                        <div className="slds-form-element slds-form-element_horizontal slds-size_1-of-2">
                                            <label className="slds-form-element__label slds-text-body_medium" htmlFor="select-01">API Name</label>
                                            <div className="slds-form-element__control">
                                                <input type='text'
                                                    role='input'
                                                    disabled={true}
                                                    value={this.generateApiName()}
                                                    className="slds-input slds-combobox__input slds-combobox__input-value" />
                                            </div>  
                                        </div> </>
                                    }
                                </div>
                            </>
                        </div>
                        <footer className="slds-modal__footer">
                            <button role='cancel-button' 
                                className="slds-button slds-button_neutral" 
                                onClick={() => this.props.toggleNbaModalVisibility()}>
                                    Cancel
                            </button>
                            <button role='save-button' 
                                disabled={this.isFormValid()} 
                                onClick={this.saveQuickActions} 
                                className="slds-button slds-button_brand" >
                                    Save
                            </button>
                        </footer>
                    </div>
                </section>
                <div className="slds-backdrop slds-backdrop_open"></div>
            </>
        );
    }

    /**
     * @memberof AddNbaModal
     * @description validates the add NBA modal form
     * @returns a boolean
     */
    isFormValid(){
        if(this.state.nbaType!=='' && this.generateApiName()!=='' && this.state.label!=='' && 
            (this.state.url || this.state.notification || this.state.name)){
                return false;
        }
        return true;        
    }
}
export const AddNbaModalComponent = observer(AddNbaModal);
